import { ManageFootballTeam } from "./admin/manage-football-team";
import { FootballCompetition } from "./football-competition";
import { FootballSeason } from "./football-season";
import { IFootballHostedCompetition } from "./interface/i-football-competition";
import { IFootballSeason } from "./interface/i-football-season";
import { IFootballTeam } from "./interface/i-football-team";

export class FootballHostedCompetition extends FootballCompetition implements IFootballHostedCompetition {
  public id: number = 0;
  public title: string = "";
  public abbreviation: string = "";
  public description: string = "";
  public logo: string = " ";
  public type: string = "";
  public teamGender: number = 0;
  public ageGroup: string = "";
  public teamForm: string = "";
  public skillLevel: string = "";
  public latestSeason: IFootballSeason = new FootballSeason();
  public hostTeam: IFootballTeam = new ManageFootballTeam();

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
